var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import loggerLevels from './logger/levels';
var config = {
    production: false,
    logLevel: loggerLevels.WARN
};
export default function (options) {
    if (options === void 0) { options = {}; }
    for (var key in options) {
        config[key] = options[key];
    }
    return __assign({}, config);
}
//# sourceMappingURL=config.js.map